import {
  selectOperatorPulseDispatch,
  selectUserProfile,
} from 'app/containers/AuthProvider/selectors';
import { actions } from 'app/containers/AuthProvider/slice';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const OPERATOR_PULSE_MS = 10000;

export const useOperatorPulse = () => {
  const userProfile = useSelector(selectUserProfile);
  const pulseState = useSelector(selectOperatorPulseDispatch);
  const dispatch = useDispatch();

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const pulseProcessing = useRef<boolean>(false);

  const callPulse = useCallback(() => {
    const { id, tenantId, accessToken } = userProfile;
    if (!id || !tenantId || !accessToken) return;

    dispatch(
      actions.setOperatorPulse({
        id,
        tenantId,
        accessToken,
      }),
    );
  }, [dispatch, userProfile]);

  useEffect(() => {
    pulseProcessing.current = pulseState.processing;
  }, [pulseState]);

  useEffect(() => {
    const scheduleNext = () => {
      timeoutRef.current = setTimeout(() => {
        if (!pulseProcessing.current) {
          callPulse();
        }
        scheduleNext();
      }, OPERATOR_PULSE_MS);
    };

    scheduleNext();

    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [callPulse]);
};
